export default "__VITE_ASSET__nBkElsud__"